import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box, Chip, TableFooter } from "@mui/material";
import { DoneAll, Clear, ExpandMoreTwoTone, ExpandLessTwoTone } from "@mui/icons-material";
import React, {useEffect, useState} from 'react'
import { motion } from "framer-motion";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Laptop from '../Assets/laptop.png'
import Report from '../Assets/report.png'
import SoftwareDevelopment from '../Assets/software-development.png'
import Content from '../Assets/content.png'
import Smartphone from '../Assets/smartphone.png'
import CustomerService from '../Assets/customer-service.png'
import '../CSS/Module.css'

export default function Hospital() {
    const [pricing, setPricing] = useState(false);
    const [showAll, setShowAll] = useState(false);
    
    useEffect(() => {
      AOS.init({ duration: 1000 }); 
    }, []);

    const handleToggleChange = () => {
        setPricing(!pricing)
    }

    const features = [
        { name: "SMS Integration*", basic: true, advanced: true, premium: true },
        { name: "WhatsApp Integration*", basic: true, advanced: true, premium: true },
        { name: "Payment Gatway Integration*", basic: true, advanced: true, premium: true },
        { name: "User Role and Permission", basic: true, advanced: true, premium: true },
        { name: "Enquiry Management", basic: true, advanced: true, premium: true },
        { name: "Admission Management", basic: true, advanced: true, premium: true },
        { name: "Transport Management", basic: true, advanced: true, premium: true },
        { name: "Fee Management", basic: true, advanced: true, premium: true },
        { name: "Fee Dues Management", basic: true, advanced: true, premium: true },
        { name: "Fee Concession Management", basic: true, advanced: true, premium: true },
        { name: "Denominator", basic: true, advanced: true, premium: true },
        { name: "Attendance Management", basic: false, advanced: true, premium: true },
        { name: "I-Card Management", basic: false, advanced: true, premium: true },
        { name: "Student Gate Pass", basic: false, advanced: true, premium: true },
        { name: "Visitor Pass", basic: false, advanced: true, premium: true },
        { name: "Appreciation Certificate", basic: false, advanced: true, premium: true },
        { name: "Bonafide/TC/Fee Certificate", basic: false, advanced: true, premium: true },
        { name: "Exam Management", basic: false, advanced: true, premium: true },
        { name: "Time Table Management", basic: false, advanced: false, premium: true },
        { name: "Library Management", basic: false, advanced: false, premium: true },
        { name: "Homework Management", basic: false, advanced: false, premium: true },
        { name: "Notice Management", basic: false, advanced: false, premium: true },
        { name: "Employee Management", basic: false, advanced: false, premium: true },
        { name: "Account Management", basic: false, advanced: false, premium: true },
        { name: "Student Web Login", basic: false, advanced: false, premium: true },
        { name: "Student App", basic: false, advanced: false, premium: true },
        { name: "Teacher App", basic: false, advanced: false, premium: true },
    ];

    const plans = [
        { name: "Basic", color: "primary" },
        { name: "Advanced", color: "secondary", popular: true },
        { name: "Premium", color: "success" },
    ];

    const displayedFeatures = showAll ? features : features.slice(0, 10);

  return (
    <>
        <section id="Solutions" className="d-flex align-items-center pt-5">
            <div className="container" data-aos="fade-up">
                <div className="section-title">
                    <h2>Features</h2>
                    <h3>Hospital Management Software <span>Features</span></h3>
                </div>
                <div className="row shadow-sm mx-1">
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-end">
                        <img src={Laptop}alt="laptop" width="40" className="icon" />
                        <h4 className="title">Easy To Use</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center">
                        <img src={Report} alt="laptop" width="40" className="icon" />
                        <h4 className="title">Attractive report based on critical and normal values</h4>
                    </div> 
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-md-start border-sm-top border-sm-end">
                        <img src={SoftwareDevelopment} alt="laptop" width="40" className="icon" />
                        <h4 className="title">Software Update time to time</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-top border-md-end">
                        <img src={Content} alt="laptop" width="40" className="icon " />
                        <h4 className="title">Patient Result Entry With Minimal Effort</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-top">
                        <img src={Smartphone} alt="laptop" width="40" className="icon" />
                        <h4 className="title">SMS Module Integration</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-top border-start">
                        <img src={CustomerService} alt="laptop" width="40" className="icon" />
                        <h4 className="title">Customer Support 24*7</h4>
                    </div>
                </div>
                <nav className='my-5 mx-2'>
                    <ul className="nav nav-tabs">
                      <li className="nav-item">
                        <span className={`nav-link ${!pricing && 'active'}`} onClick={handleToggleChange}>Modules</span>
                      </li>
                      {/* <li className="nav-item">
                        <span className={`nav-link ${pricing && 'active'}`} onClick={handleToggleChange}>Pricing</span>
                      </li> */}
                    </ul>
                </nav>
                {!pricing &&
                    <div className="container">
                        <div className="section-title" data-aos="fade-up">
                          <h2>Modules</h2>
                          <h3>Software Module <span>Details</span></h3>
                        </div>
                        <div className="row">
                            <div className="col-md-4" data-aos="fade-right">
                                <div className="shadow-lg bg-white rounded border module-card">
                                    <ul>
                                        <h5>Create Master Form</h5>
                                        <li>City Master</li>
                                        <li>Location  Master</li>
                                        <li>Doctor Master with OPD/Visit Charges</li>
                                        <li>Surgery  Master</li>
                                        <li>Surgery Requirement Master</li>
                                        <li>IPD/OT Expense Category Master</li>
                                    </ul>
                                    <ul>
                                        <h5>OPD Management</h5>
                                        <li>Patient Registration (New Patient)</li>
                                        <li>Generate UHID No</li>
                                        <li>Generate Daily Queue No (First Come First Serve Basis)</li>
                                        <li>OPD Re-Registration from UHID/MobileNo/AdharNo</li>
                                        <li>OPD Registration (Old Patient)</li>
                                        <li>Track Old Patient History</li>
                                    </ul>
                                    <ul>
                                        <h5>IPD/OT Management</h5>
                                        <li>Patient Registration (If New)</li>
                                        <li>Patient Admission from UHID/MobileNo/AdharNo</li>
                                        <li>Create Medical Notes & Summary</li>
                                        <li>Print Consent if Any</li>
                                        <li>Assign Room/Ward/Bed</li>
                                        <li>Assign Consultant/Surgeon</li>
                                        <li>Create Schedule for Surgery</li>
                                        <li>Create Teams (Doctor/Staff)</li>
                                        <li>Fill Consent form</li>
                                        <li>Create Surgery Remarks/Notes</li>
                                        <li>Create Consumable Items List</li>
                                        <li>Print Consumable Items List</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4" data-aos="fade-down">
                                <div className="shadow-lg bg-white rounded border module-card">
                                    <ul>
                                        <h5>Patient Follow up</h5>
                                        <li>Daily Auto Generate Followup List</li>
                                        <li>Note Followup Remarks and Add Next Followup Date/Close the followup</li>
                                        <li>View/Print Daily Folloup Notes</li>
                                        <li>View/Print Followup Summary With Multiple Filter</li>
                                    </ul>
                                    <ul>
                                        <h5>Bills</h5>
                                        <li>Print Registration Bill (A5 Page)</li>
                                        <li>Print Patient Details (A4) for Dr Prescription</li>
                                        <li>Pathology, X-Ray & Ultrasound Billing and Receipt Print</li>
                                        <li>Create/Print Advance Payment Collection</li>
                                        <li>Create Bill Surgery</li>
                                        <li>IPD/OT Final Bill Creation</li>
                                        <ul>
                                            <h5>DashBoard</h5>
                                            <li>View/Print Patient History(UHID/AdharNo)</li>
                                            <li>Graphical Representation of Patient Ward/Bed Wise</li>
                                            <li>Today No of Patient Admit/Discharge</li>
                                            <li>Today No of Patient Admit/Discharge (Department Wise)</li>
                                            <li>Current Month Patient Admit/Discharge (Department Wise)</li>
                                        </ul>
                                    </ul>
                                    <ul>
                                        <h5>Accounts</h5>
                                        <li>Create Group</li>
                                        <li>Create Ledger</li>
                                        <li>Create Patient Wise Daily Bill</li>
                                        <li>View Patient Bill Statement</li>
                                        <li>View Day wise Income/Expense Summary</li>
                                        <li>Create Journal Voucher</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4" data-aos="fade-up">
                                <div className="shadow-lg bg-white rounded border module-card">
                                    <ul>
                                        <h5>Pharmacy & POS</h5>
                                        <li>Create Group</li>
                                        <li>Create Ledger</li>
                                        <li>Create Medicine Category(Tab/Inj/Syrup)</li>
                                        <li>Create Medicine Inventory</li>
                                        <li>Medicine Stock with Multiple Filter</li>
                                        <li>Create PO(Indent)</li>
                                    </ul>
                                    <ul>
                                        <h5>Payroll Management</h5>
                                        <li>Create Department</li>
                                        <li>Create Designation</li>
                                        <li>Create ESI PF Details</li>
                                        <li>Add Staff</li>
                                        <li>View Staff Details(filter apply)</li>
                                        <li>View Basic Salary</li>
                                    </ul>
                                    <ul>
                                        <h5>SMS Integration*</h5>
                                        <li>User defined SMS Template</li>
                                        <li>SMS in OPD/IPD/Diagnosis</li>
                                        <li>SMS in Accounts/Bill</li>
                                        <li>SMS in Employee/Doctor/Other</li>
                                        <li>SMS in Offer/Announcement</li>
                                        <li>*Optional Service, SMS Charges Applicable</li>
                                    </ul>
                                    <ul>
                                        <h5>MIS Reports</h5>
                                        <li>Daily OPD/IPD/Investigation Report</li>
                                        <li>Daily Collection Report Department Wise</li>
                                        <li>Daily Expense Report</li>
                                        <li>Bed Occupied Details Graphically</li>
                                        <li>Employee Details</li>
                                        <li>Employee Leave Details</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {pricing &&
                  <Box sx={{ maxWidth: 1400, mx: "auto", textAlign: "center", p: 2 }} data-aos="fade-down">
                    <Typography variant="h3" fontWeight={600} color="primary" gutterBottom>Compare Plans</Typography>
                    <TableContainer sx={{ overflow: "scroll" }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell align="center" sx={{ transform: "scale(1.1)", background: "#D0021B", color: "white", fontWeight: "bold", fontSize: "0.8rem", padding: "4px 10px", borderTopLeftRadius: '10px', borderTopRightRadius: '10px', boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)"}}>Most Popular</TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                          <TableRow sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"}}>
                            <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "1.2rem", borderTopLeftRadius: '10px' }}>Features</TableCell>
                            {plans.map((plan, idx) => (
                              <TableCell key={idx} sx={{ color: "white", fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.1rem" }, position: "relative", transform: plan.popular ? "scale(1.1)" : "none", zIndex: plan.popular ? 2 : 1, backgroundColor: plan.popular ? "rgba(255, 255, 255, 0.2)" : "inherit", backdropFilter: plan.popular ? "blur(5px)" : "none", borderRadius: plan.popular ? "8px" : "0px", borderTopRightRadius: plan.popular ? "0px" : "10px", boxShadow: plan.popular ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none" }} align="center">
                                {plan.name}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {displayedFeatures.map((feature, index) => (
                            <TableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff", "& td": { py: 1 } }}>
                              <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>{feature.name}</TableCell>
                              {plans.map((plan, idx) => (
                                <TableCell key={idx} align="center" sx={{
                                  transform: plan.popular ? "scale(1.1)" : "none",
                                  zIndex: plan.popular ? 2 : 1,
                                  backgroundColor: plan.popular ? "rgba(255, 255, 255, 0.3)" : "inherit",
                                  backdropFilter: plan.popular ? "blur(5px)" : "none",
                                  borderRadius: plan.popular ? "8px" : "0px",
                                  boxShadow: plan.popular ? "0px 4px 10px rgba(0, 0, 0, 0.5)" : "none"
                                }}>
                                  {feature[plan.name.toLowerCase()] ? (
                                    <motion.div whileHover={{ scale: 1.2 }}>
                                      <DoneAll color="success" fontSize="medium" />
                                    </motion.div>
                                  ) : (
                                    <motion.div whileHover={{ scale: 1.2 }}>
                                      <Clear color="error" fontSize="medium" />
                                    </motion.div>
                                  )}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                        <TableFooter>
                          <Chip sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)", background: "#D0021B", color: "#fff", zIndex: 3 }} icon={showAll ? <ExpandLessTwoTone color="white" /> : <ExpandMoreTwoTone color="white" />} onClick={() => setShowAll(!showAll)} label={showAll ? "Show Less" : "View More"} />
                          <TableRow sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"}}>
                            <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.1rem" }, borderTopLeftRadius: '10px' }}>NO OF STUDENTS</TableCell>
                            {plans.map((plan, idx) => (
                              <TableCell key={idx} sx={{ color: "white", fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.1rem" }, position: "relative", transform: plan.popular ? "scale(1.1)" : "none", zIndex: plan.popular ? 2 : 1, backgroundColor: plan.popular ? "rgba(255, 255, 255, 0.2)" : "inherit", backdropFilter: plan.popular ? "blur(5px)" : "none", borderRadius: plan.popular ? "8px" : "0px", borderTopRightRadius: plan.popular ? "0px" : "10px", boxShadow: plan.popular ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none" }} align="center">
                                {plan.name}
                              </TableCell>
                            ))}
                          </TableRow>
                          <TableRow sx={{ backgroundColor: "#f9f9f9", "& td": { py: 1 } }}>
                            <TableCell sx={{  background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)", color: "#fff", fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>Upto 300</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">9,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" }, transform: "scale(1.1)", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.3)",  backdropFilter: "blur(5px)", borderRadius: "8px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)"}} align="center">14,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">19,999/Year</TableCell>
                          </TableRow>
                          <TableRow sx={{ backgroundColor: "#fff", "& td": { py: 1 } }}>
                            <TableCell sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)", color: "#fff", fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>301- 500</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">14,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" }, transform: "scale(1.1)", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.3)",  backdropFilter: "blur(5px)", borderRadius: "8px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)"}} align="center">19,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">24,999/Year</TableCell>
                          </TableRow>
                          <TableRow sx={{ backgroundColor: "#f9f9f9", "& td": { py: 1 } }}>
                            <TableCell sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)", color: "#fff", fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>500 +</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">Rs. 5/Per Student/Per Month</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" }, transform: "scale(1.1)", zIndex: 2, backgroundColor: "rgba(255, 255, 255, 0.3)",  backdropFilter: "blur(5px)", borderRadius: "8px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)"}} align="center">Rs 7/Per Student/Per Month</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">Rs 10/Per Student/Per Month</TableCell>
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </Box>
                }
            </div>
        </section>
    </>
  )
}


